import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import TemplateData, { localsMessages } from '../../utility/getTemplateData';
import { showSpinnerOverlay } from '../../utility/helper';
import { fetcher } from '../../utility/domUtils';
import _get from 'lodash/get';

const messages = localsMessages('confirmation/postTransaction') || {};

export default class extends React.Component {
  constructor(props) {
    super(props);

    const { postdata = {}, syncReturnUrl = '' } = this.props || {};

    let postBackArray = [];

    Object.keys(postdata).forEach(function (key) {
      postBackArray.push({
        name: key,
        value: postdata[key],
      });
    });

    this.state = {
      orgName: this.props.orgName,
      redirectMethod: this.props.method,
      redirectUrl: this.props.action,
      syncReturnUrl,
      postBackArray,
    };
  }

  componentDidMount() {
    this.handleRedirect();

    //No need to handle refresh case
    //As user will be automatically redirected back
    //In case if some is required, listening to UPDATE_CONFIRMATION
    // AppDispatcher.register(function(payload) {
    //	 if (payload.action && (payload.action.actionType === 'UPDATE_CONFIRMATION')) {}
    // });
  }

  /*
   * handleRedirect
   */
  handleRedirect = () => {
    let { syncReturnUrl = '', redirectUrl = '', redirectMethod = '' } =
      this.state || {};

    setTimeout(() => showSpinnerOverlay(), 12000);
    setTimeout(() => {
      fetcher('/donate/sessionlogout').finally(() => {
        if (redirectMethod === 'POST' && syncReturnUrl) {
          this.postBackForm.submit();
        } else if (redirectMethod === 'GET' && syncReturnUrl) {
          if (
            syncReturnUrl.indexOf('http') != 0 &&
            syncReturnUrl.indexOf('//') != 0
          ) {
            syncReturnUrl = '//' + syncReturnUrl;
          }
          window.location.href = syncReturnUrl;
        } else {
          if (
            redirectUrl.indexOf('http') != 0 &&
            redirectUrl.indexOf('//') != 0
          ) {
            redirectUrl = '//' + redirectUrl;
          }
          window.location.href = redirectUrl;
        }
      });
    }, 15000);
  };

  render() {
    if (this.state.orgName) {
      let redirectText = _get(messages, 'label.redirectText');

      redirectText = redirectText.replace('{orgName}', this.state.orgName);
      document.getElementById('spinnerText').innerHTML = redirectText;
    }

    return (
      <div>
        <form
          name="postBackForm"
          method={this.props.method}
          action={this.props.action}
          ref={(form) => {
            this.postBackForm = form;
          }}
        >
          {' '}
          {this.state.postBackArray.map(function (obj) {
            return (
              <input
                type="hidden"
                key={obj.name}
                name={obj.name}
                defaultValue={obj.value}
              />
            );
          })}
        </form>
      </div>
    );
  }
}
